function isSpecialThresholdToken(value) {
  const token = String(value ?? '').trim().toUpperCase();
  return token === 'OFF' || token === 'ON';
}

function parseThresholdValue(raw) {
  if (Array.isArray(raw)) {
    return { min: raw[0] ?? '', max: raw[1] ?? '' };
  }
  if (typeof raw === 'string') {
    if (isSpecialThresholdToken(raw)) {
      return { min: '', max: '' };
    }
    const parts = raw
      .split(/\s*-\s*|,|;/)
      .map((item) => item.trim())
      .filter(Boolean);
    return { min: parts[0] ?? '', max: parts[1] ?? '' };
  }
  if (typeof raw === 'number') {
    return { min: '', max: String(raw) };
  }
  return { min: '', max: '' };
}

function serializeThresholdValue(value) {
  const left = String(value?.min ?? '').trim();
  const right = String(value?.max ?? '').trim();
  if ((left && isSpecialThresholdToken(left)) || (right && isSpecialThresholdToken(right))) {
    return null;
  }
  if (!left && !right) return null;
  if (!left) return right;
  if (!right) return left;
  return `${left}-${right}`;
}

export function buildClimateThresholdState(thresholds = {}) {
  return {
    day: {
      temperature: parseThresholdValue(thresholds?.day?.temperature ?? thresholds?.tempDay),
      humidity: parseThresholdValue(thresholds?.day?.humidity ?? thresholds?.humDay),
      co2: parseThresholdValue(thresholds?.day?.co2 ?? thresholds?.co2Day),
    },
    night: {
      temperature: parseThresholdValue(thresholds?.night?.temperature ?? thresholds?.tempNight),
      humidity: parseThresholdValue(thresholds?.night?.humidity ?? thresholds?.humNight),
      co2: parseThresholdValue(thresholds?.night?.co2 ?? thresholds?.co2Night),
    },
  };
}

export function serializeClimateThresholds(thresholdState = {}) {
  const payload = {
    temp_day: serializeThresholdValue(thresholdState?.day?.temperature),
    hum_day: serializeThresholdValue(thresholdState?.day?.humidity),
    co2_day: serializeThresholdValue(thresholdState?.day?.co2),
    temp_night: serializeThresholdValue(thresholdState?.night?.temperature),
    hum_night: serializeThresholdValue(thresholdState?.night?.humidity),
    co2_night: serializeThresholdValue(thresholdState?.night?.co2),
  };
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value));
}
